// TypographyVariantsOptions is createTypography's TypographyOptions re-exported
// under a public alias — @mui/material/styles does not export the original name.
import { TypographyVariantsOptions } from '@mui/material/styles';

import { AppViewMode } from 'src/constants';
import { PortalConfig } from 'src/context';
import { BlackHeadings } from 'src/theme/colors';
import * as Weights from 'src/theme/weights';
import { resolveFont } from 'src/utils/FontUtils';

export const generateTypographyV5 = (
  portalConfig: PortalConfig,
): TypographyVariantsOptions => {
  const isClient = portalConfig.viewMode === AppViewMode.CLIENT;
  const { fontFamily: resolvedFontFamily } = resolveFont(
    portalConfig.brand.clientFontFamily,
    isClient,
  );

  const fontFamily = [
    `"${resolvedFontFamily}"`,
    '"Helvetica"',
    '"Arial"',
    'sans-serif',
  ].join(',');

  return {
    fontFamily,
    h1: {
      color: BlackHeadings,
      fontWeight: Weights.medium,
      fontSize: '58px',
      letterSpacing: '-0.24px',
      lineHeight: '70px',
    },
    h2: {
      color: BlackHeadings,
      fontWeight: Weights.medium,
      fontSize: '24px',
      letterSpacing: '-0.24px',
      lineHeight: '30px',
    },
    h3: {
      color: BlackHeadings,
      fontStyle: 'normal',
      fontWeight: Weights.medium,
      fontSize: '18px',
      lineHeight: '24px',
    },
    h4: {
      color: BlackHeadings,
      fontStyle: 'normal',
      fontWeight: Weights.medium,
      fontSize: '15px',
      lineHeight: '24px',
    },
    h5: {
      color: BlackHeadings,
      fontWeight: Weights.regular,
      fontSize: '14px',
      letterSpacing: '-0.05px',
      lineHeight: '20px',
    },
    h6: {
      color: BlackHeadings,
      fontStyle: 'normal',
      fontWeight: Weights.regular,
      fontSize: '12px',
      lineHeight: '24px',
    },
    subtitle1: {
      color: BlackHeadings,
      fontWeight: Weights.regular,
      fontSize: '9px',
      letterSpacing: '-0.05px',
      lineHeight: '25px',
    },
    subtitle2: {
      color: BlackHeadings,
      fontWeight: Weights.regular,
      fontSize: '14px',
      letterSpacing: '-0.05px',
      lineHeight: '21px',
    },
    body1: {
      color: BlackHeadings,
      fontWeight: Weights.regular,
      fontSize: '13px',
      letterSpacing: '-0.05px',
      lineHeight: '20px',
    },
    body2: {
      fontStyle: 'normal',
      fontSize: '13px',
      lineHeight: '24px',
      fontWeight: Weights.medium,
    },
    button: {
      color: BlackHeadings,
      fontSize: '16px',
      textTransform: 'none',
    },
    caption: {
      color: portalConfig.theme.palette.text.secondary,
      fontSize: '11px',
      letterSpacing: '0.33px',
      lineHeight: '13px',
    },
    overline: {
      color: portalConfig.theme.palette.text.secondary,
      fontSize: '11px',
      fontWeight: Weights.semiBold,
      letterSpacing: '0.33px',
      lineHeight: '13px',
      textTransform: 'uppercase',
    },
  };
};
